import React from "react";
import { FaWhatsapp, FaLinkedin, FaEnvelope, FaCheck } from "react-icons/fa";
import styles from "../ReferralPage.module.css";

const ReferralShare = ({
    shareUrl,
    copied,
    animateForm,
    copyToClipboard,
    handleSocialShare
}) => {
    return (
        <div className={`${styles.shareCard} ${animateForm ? styles.animate : ''}`}>
            <div className={styles.cardHeader}>
                <h2>Share Your Referral Link</h2>
            </div>
            <div className={styles.referralLinkContainer}>
                <p>Share this unique link with your friends:</p>
                <div className={styles.linkBox}>
                    <input
                        type="text"
                        value={shareUrl}
                        readOnly
                        onClick={copyToClipboard}
                    />
                    <button
                        className={styles.copyButton}
                        onClick={copyToClipboard}
                        title="Copy to clipboard"
                    >
                        {copied ? <FaCheck /> : 'Copy'}
                    </button>
                </div>
            </div>

            <div className={styles.socialShareContainer}>
                <p>Or share via:</p>
                <div className={styles.socialButtons}>
                    <button
                        className={`${styles.socialButton} ${styles.whatsapp}`}
                        onClick={() => handleSocialShare('whatsapp')}
                    >
                        <FaWhatsapp />
                        <span>WhatsApp</span>
                    </button>
                    <button
                        className={`${styles.socialButton} ${styles.linkedin}`}
                        onClick={() => handleSocialShare('linkedin')}
                    >
                        <FaLinkedin />
                        <span>LinkedIn</span>
                    </button>
                    <button
                        className={`${styles.socialButton} ${styles.email}`}
                        onClick={() => handleSocialShare('email')}
                    >
                        <FaEnvelope />
                        <span>Email</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReferralShare;
